module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14unkS6/tc-custom/9781398466593.jpg?1705541169370",
      "alt": "This image is the cover for the book Lorrie and I"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lorrie and I\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“When Lorrie looked at me in a bath of blood, he quickly went to the laundry and took a big clean towel wet with hot water. He carefully wrapped me up. He then gently bathed me in it. I looked Lorrie in his eyes and felt comforted. Lorrie carried me to his office and placed a silky blanket over me to keep me warm. He put me in a paper box lined with a towel. I felt no pain! The journey to the vet took 15 minutes. Lorrie kept singing to me and touching my head and shoulder. It seemed a very long journey as he drove steadily along on the road.” Coco the feline knew his final hour is coming; it didn’t end his longing for the comfort and touches of his master!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Che Kwok Wong\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("David Che Kwok Wong has a Master Degree of Education and a Master Degree of Development Management. He enjoys spending most of his time working among ordinary people. He loves listening and associating with people, a great privilege to be called their friend. He loves travelling and keeping his journal with him at all times.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0